import { Mui, MuiIcons } from "@osu/react-ui";
import { Fragment } from "react";

const NoAccess = () => {
  return (
    <Fragment>
      <Mui.Alert aria-live="polite" aria-atomic="true" severity="warning">
        You do not have access to submit entries. Please contact{" "}
        <Mui.Link
          variant="subtitle2"
          color="inherit"
          href="mailto:sae-sfa-compliance@osu.edu"
        >
          Student Financial Aid Compliance{" "}
          <MuiIcons.Email titleAccess="e-mail" color="inherit" fontSize="inherit" />
        </Mui.Link>{" "}
        with questions or to request access.
      </Mui.Alert>
    </Fragment>
  );
};

export default NoAccess;
